import { useAppSelector } from '@/app/redux/hooks';
import { useCurrentOrganisationId } from '@/app/redux/hooks/organisation';
import { selectShareLink } from '@/app/redux/slices/shareLinkSlice';
import { Attempt } from '@/common/types/session';
import GraphemeAccuracy from '@/dashboard/Insights/GraphemeAccuracy';
import api from '@/db/apiClient';
import { useEffect, useState } from 'react';

interface LearnerInsightsProps {
  studentId: string;
}
export default function LearnerInsights({ studentId }: LearnerInsightsProps) {
  const { currentOrganisationId } = useCurrentOrganisationId();

  const { student } = useAppSelector(selectShareLink);
  const organisationId = student?.organisationId ?? currentOrganisationId;

  const [isAttemptsLoading, setAttemptsLoading] = useState(true);
  const [attempts, setAttempts] = useState<Attempt[]>([]);

  useEffect(() => {
    (async () => {
      if (!organisationId) return;
      try {
        setAttemptsLoading(true);
        const service = api.asShareLink ?? api.asEducator;
        const attempts = await service.getAttemptsForStudent(
          organisationId,
          studentId,
        );
        setAttempts(attempts);
      } catch (error) {
        console.error(error);
      } finally {
        setAttemptsLoading(false);
      }
    })();
  }, [organisationId, studentId]);

  return (
    <div className="p-2">
      <GraphemeAccuracy attempts={attempts} loading={isAttemptsLoading} />
    </div>
  );
}
